<script>
import * as m from '@app/paraglide/messages.js';
import { push } from 'svelte-spa-router'
import { onMount } from 'svelte'

let animationDelay = 0;

onMount(() => {
    // Add a subtle entrance animation delay
    setTimeout(() => {
        animationDelay = 1;
    }, 100);
});

function goHome() {
    push('/');
}

function refreshPage() {
    window.location.reload();
}
</script>

<div id="OfflineScreen" class:animate={animationDelay}>
    <div class="container d-flex justify-content-center align-items-center offline-wrapper">
        <div class="col-md-6 col-sm-8 col-11 shadow offline-content text-white rounded border-0">
            <!-- Logo section -->
            <div class="d-flex justify-content-center align-items-center mb-4">
                <img src="./cc-logo.png" width="150px" alt={m.app_logo_alt()} class="logo-fade"/>
            </div>
            
            <!-- Main error content -->
            <div class="text-center mb-4">
                <div class="error-code mb-3">
                    <span class="large-text">{m.offline_error_code()}</span>
                </div>
                <h2 class="error-title mb-3">{m.offline_error_title()}</h2>
                <p class="error-description">
                    {m.offline_error_description()}
                </p>
            </div>

            <!-- Status indicators -->
            <div class="status-grid mb-4">
                <div class="status-item">
                    <div class="status-icon offline">
                        <i class="bi bi-wifi-off"></i>
                    </div>
                    <span>{m.offline_status_connectivity()}</span>
                </div>
                <div class="status-item">
                    <div class="status-icon offline">
                        <i class="bi bi-server"></i>
                    </div>
                    <span>{m.offline_status_services()}</span>
                </div>
                <div class="status-item">
                    <div class="status-icon offline">
                        <i class="bi bi-shield-check"></i>
                    </div>
                    <span>{m.offline_status_authentication()}</span>
                </div>
            </div>

            <!-- Action buttons -->
            <div class="action-buttons">
                <button class="btn btn-primary btn-lg me-3 mb-2" onclick={refreshPage}>
                    <i class="bi bi-arrow-clockwise me-2"></i>
                    {m.offline_retry_button()}
                </button>
                <button class="btn btn-outline-light btn-lg mb-2" onclick={goHome}>
                    <i class="bi bi-house me-2"></i>
                    {m.offline_go_home_button()}
                </button>
            </div>

            <!-- Support information -->
            <div class="support-info text-center">
                <small class="form-text text-white-50">
                    {m.offline_support_text()}
                    <br>
                    <a href="mailto:support@closedcaptioncreator.com" class="support-link">
                        support@closedcaptioncreator.com
                    </a>
                </small>
            </div>
        </div>
    </div>

    <!-- Background animated elements -->
    <div class="bg-animation">
        <div class="floating-element element-1"></div>
        <div class="floating-element element-2"></div>
        <div class="floating-element element-3"></div>
    </div>
</div>

<style lang="css">
#OfflineScreen {
    position: relative;
    height: 100vh;
    width: 100vw;
    overflow: hidden;
    color: #f0f0f0;
    font-family: 'Lato', sans-serif;
    background: #000000;
    background: linear-gradient(154deg, rgba(0, 0, 0, 1) 0%, rgba(15, 28, 35, 1) 50%, rgba(33, 37, 41, 1) 100%);
    opacity: 0;
    transform: translateY(20px);
    transition: all 0.8s ease-out;
}

#OfflineScreen.animate {
    opacity: 1;
    transform: translateY(0);
}

.offline-wrapper {
    height: 100vh;
    position: relative;
    z-index: 10;
}

.offline-content {
    background: rgba(0, 0, 0, 0.6);
    backdrop-filter: blur(15px);
    border-radius: 20px;
    padding: 50px 40px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
    border: 1px solid rgba(255, 255, 255, 0.1);
    animation: contentFadeIn 1s ease-out 0.3s both;
}

.logo-fade {
    opacity: 0.9;
    filter: grayscale(20%);
    transition: all 0.3s ease;
}

.logo-fade:hover {
    opacity: 1;
    filter: grayscale(0%);
}

.error-code {
    font-family: 'plexMono', monospace;
    font-weight: 700;
    color: #0fbc8c;
    opacity: 0.8;
}

.large-text {
    font-size: 4rem;
    text-shadow: 0 0 20px rgba(15, 188, 140, 0.3);
}

.error-title {
    font-size: 2rem;
    font-weight: 600;
    margin-bottom: 1rem;
    color: #ffffff;
}

.error-description {
    font-size: 1.1rem;
    line-height: 1.6;
    color: #e0e0e0;
    max-width: 80%;
    margin: 0 auto;
}

.status-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 1.5rem;
    padding: 1.5rem 0;
}

.status-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.5rem;
}

.status-icon {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.5rem;
    transition: all 0.3s ease;
}

.status-icon.offline {
    background: rgba(231, 76, 60, 0.2);
    color: #e74c3c;
    border: 2px solid rgba(231, 76, 60, 0.3);
}

.status-item span {
    font-size: 0.9rem;
    color: #b0b0b0;
}

.action-buttons {
    text-align: center;
    margin: 2rem 0;
}

.btn {
    transition: all 0.3s ease;
    font-weight: 500;
}

.btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.3);
}

.btn-primary {
    background: linear-gradient(45deg, #0fbc8c, #00a372);
    border: none;
    box-shadow: 0 4px 15px rgba(15, 188, 140, 0.3);
}

.btn-primary:hover {
    background: linear-gradient(45deg, #00a372, #008762);
    box-shadow: 0 8px 25px rgba(15, 188, 140, 0.4);
}

.btn-outline-light {
    border: 2px solid rgba(255, 255, 255, 0.3);
    color: #ffffff;
    background: rgba(255, 255, 255, 0.05);
}

.btn-outline-light:hover {
    background: rgba(255, 255, 255, 0.1);
    border-color: rgba(255, 255, 255, 0.5);
    color: #ffffff;
}

.support-info {
    margin-top: 2rem;
    padding-top: 1.5rem;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.support-link {
    color: #0fbc8c;
    text-decoration: none;
    transition: color 0.3s ease;
}

.support-link:hover {
    color: #00ebaa;
    text-decoration: underline;
}

/* Background Animation */
.bg-animation {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    z-index: 1;
}

.floating-element {
    position: absolute;
    border-radius: 50%;
    background: linear-gradient(45deg, rgba(15, 188, 140, 0.1), rgba(0, 235, 170, 0.05));
    animation: float 6s ease-in-out infinite;
}

.element-1 {
    width: 100px;
    height: 100px;
    top: 20%;
    left: 10%;
    animation-delay: 0s;
    animation-duration: 8s;
}

.element-2 {
    width: 150px;
    height: 150px;
    top: 60%;
    right: 15%;
    animation-delay: 2s;
    animation-duration: 10s;
}

.element-3 {
    width: 80px;
    height: 80px;
    bottom: 20%;
    left: 70%;
    animation-delay: 4s;
    animation-duration: 7s;
}

/* Animations */
@keyframes contentFadeIn {
    0% {
        opacity: 0;
        transform: scale(0.95) translateY(30px);
    }
    100% {
        opacity: 1;
        transform: scale(1) translateY(0);
    }
}

@keyframes float {
    0%, 100% {
        transform: translateY(0px) rotate(0deg);
        opacity: 0.3;
    }
    50% {
        transform: translateY(-20px) rotate(180deg);
        opacity: 0.1;
    }
}

/* Responsive Design */
@media (max-width: 768px) {
    .offline-content {
        padding: 40px 25px;
        margin: 20px;
    }
    
    .large-text {
        font-size: 3rem;
    }
    
    .error-title {
        font-size: 1.5rem;
    }
    
    .error-description {
        font-size: 1rem;
        max-width: 95%;
    }
    
    .status-grid {
        grid-template-columns: 1fr;
        gap: 1rem;
    }
    
    .action-buttons .btn {
        display: block;
        width: 100%;
        margin-bottom: 1rem;
    }
}

@media (max-width: 480px) {
    .offline-content {
        padding: 30px 20px;
    }
    
    .large-text {
        font-size: 2.5rem;
    }
    
    .floating-element {
        display: none;
    }
}
</style>